import React, { useEffect } from 'react'
import { useState } from "react"
import "./CustomPackage.scoped.scss"
import { apiClient } from '../../../../api'

const CustomPackage = ({ onClickToPage }) => {
  const [price, setPrice] = useState("350")
  const [customPackageRate, setCustomPackageRate] = useState(null)

  const handlePriceChange = (e) => {
    const value = e.target.value

    if (value === "" || /^\d*$/.test(value)) {
      setPrice(value)
    }
  }

  const handlePriceBlur = () => {
    if (price === "" || Number(price) < 350) {
      setPrice("350")
    } else if (Number(price) > 135000) {
      setPrice("135000")
    }
  }

  const getCustomPackageRate = () => {
    apiClient.get('api/accounts/custom-package-rate')
      .then((response) => {
        const json = response.data;
        setCustomPackageRate(json.customePackageRate)
      })
      .catch(error => console.error('Error fetching JSON:', error));
  }

  useEffect(() => {
    getCustomPackageRate()
  }, [])

  return (
    <div className="custom-package">
      <div className="package-header">
        <h2 className="package-title">Custom Package</h2>
        <div className="package-features">
          <div className="feature-group">
            <div className="feature-item">
              <span className="checkmark">✓</span>
              <span className="feature-text">Credit period : 12 Month</span>
            </div>
            <div className="feature-item">
              <span className="checkmark">✓</span>
              <span className="feature-text">Report : 12 Month</span>
            </div>
          </div>

          <div className="feature-group">
            <div className="feature-item">
              <span className="checkmark">✓</span>
              <span className="feature-text">SMS Qty : {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price / customPackageRate)}</span>
            </div>
            <div className="feature-item">
              <span className="checkmark">✓</span>
              <span className="feature-text">Sender name : 5</span>
            </div>
          </div>
        </div>
      </div>

      <div className="package-content">
        <div className="price-section">
          <h3 className="section-title">Price</h3>
          <input
            type="number"
            value={price}
            onChange={handlePriceChange}
            onBlur={handlePriceBlur}
            min="350"
            max="135000"
            className="price-input"
          />
          <p className="price-note">The minimum purchase amount you can make is 350 Baht.</p>
        </div>

        <div className="credit-section">
          <h3 className="section-title">Number of credit you got.</h3>
          <div className="credit-amount">{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price / customPackageRate)}</div>
        </div>

        <div className='package-btn'>
          <button
            className="buy-now-btn"
            onClick={() => {
              let pid = 0 + "|" + price;
              onClickToPage("custom", pid)
            }}
          >
            Buy now
          </button>
        </div>
      </div>
    </div>
  )
}

export default CustomPackage